import Vue from "vue";
export default Vue.extend({
    props: {
        item: Object,
        index: Number
    },
    methods: {
        startDrag: function (event) {
            this.$emit("selected", [event, this.index]);
        },
        openEditor: function () {
            this.$emit("open", this.index);
        }
    },
    computed: {
        toPosition: function () {
            return "translate(" + this.item.x + ", " + this.item.y + ")";
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/FusenGroup.vue
// module id = 16
// module chunks = 0